import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from 'context/AuthContext';
import { useTranslation } from 'i18n/LocaleContext';
import MetaDecorator from 'components/layout/MetaDecorator';

export function LoginPage() {
  const { signinRedirect, user, isLoading } = useAuth();
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const basePath = process.env.REACT_APP_BASE_PATH || '';
  const rawReturnUrl = location.state?.returnUrl || process.env.REACT_APP_DETAILS_REDIRECT || '/';
  const returnUrl = rawReturnUrl.startsWith(basePath)
    ? rawReturnUrl.slice(basePath.length) || '/'
    : rawReturnUrl;

  useEffect(() => {
    if (!isLoading && user && !user.guest) {
      navigate(returnUrl, { replace: true });
    }
  }, [user, isLoading, navigate, returnUrl]);

  return (
    <div className='flex-1 flex items-center justify-center py-10'>
      <MetaDecorator
        title={t('COMPONENT.LOG_IN.MENU.HEADING')}
        description='Log in to your Roland Cloud account.'
        link='login'
        addPostfixTitle
        noIndex
      />
      <div className='max-w-[680px] w-full text-center space-y-14'>
        <h2 className='font-bold mb-4 proxima-nova-bold' style={{ fontSize: '48px' }}>
          {t('COMPONENT.LOG_IN.MENU.HEADING')}
        </h2>
        <p className='text-gray-600 mb-10 px-4 leading-relaxed' style={{ fontSize: '20px' }}>
          {t('COMPONENT.LOG_IN.MENU.DESCRIPTION')}
        </p>
        <div className='flex flex-col md:flex-row items-center justify-center gap-4 md:gap-[50px]'>
          <button
            type='button'
            onClick={() => signinRedirect(rawReturnUrl)}
            className='btn-primary proxima-nova-bold w-[250px] md:w-[140px]'
            style={{
              height: '46px',
              fontSize: '18px',
              fontWeight: 'bold',
            }}
          >
            {t('COMPONENT.LOG_IN.BUTTON.LOG_IN')}
          </button>
        </div>
      </div>
    </div>
  );
}
